// src/components/Toast.js
import React, { useEffect } from "react";
import "./Toast.css";

/**
 * Toast notification component for success/error/info messages
 * @param {Object} props
 * @param {string} props.message - Message to display
 * @param {string} props.type - Type: "success", "error", "info", "warning" (default: "success")
 * @param {Function} props.onClose - Callback when toast is dismissed
 * @param {number} props.duration - Auto-dismiss duration in ms (default: 3000, 0 = no auto-dismiss)
 * @param {boolean} props.show - Whether to show the toast
 */
export default function Toast({ 
  message, 
  type = "success", 
  onClose, 
  duration = 3000,
  show = true 
}) {
  useEffect(() => {
    if (show && duration > 0 && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  if (!show || !message) return null;

  const icons = {
    success: "✓",
    error: "✕",
    info: "ℹ",
    warning: "⚠"
  };

  return (
    <div className={`toast toast-${type}`} role="alert">
      <div className="toast-icon">{icons[type] || icons.success}</div>
      <div className="toast-message">{message}</div>
      {onClose && (
        <button 
          className="toast-close" 
          onClick={onClose}
          aria-label="Dismiss notification"
        >
          ×
        </button>
      )}
    </div>
  );
}

